// extracted by mini-css-extract-plugin
export default {"list":"Pager_list__T0zvg","pg":"Pager_pg__gmqXV","on":"Pager_on__TNOmk","tap":"Pager_tap__PmK5-","gap":"Pager_gap__NJK+9","arrow":"Pager_arrow__eDnwS","flip":"Pager_flip__c0fnn"};